/**
 * TeamMatchupImage Component
 */

import React from 'react';
import { TeamMatchupImageProps, GetSrcProps } from './teamMatchupImage.types';
import Image from '../Image/image';

export const getSrc = ({ away, home, ratio, width }: GetSrcProps) =>
  `https://midfield.mlbstatic.com/v1/teams-matchup/${away}-${home}/ar_${ratio}/w_${width}`;

const TeamMatchupImage = ({
  awayTeamId,
  homeTeamId,
  ratio,
  srcsetWidth,
  srcWidth,
  ...props
}: TeamMatchupImageProps) => {
  const src = getSrc({
    away: awayTeamId,
    home: homeTeamId,
    ratio,
    width: srcWidth,
  });
  let srcset: { [key: string]: string } = {};
  if (srcsetWidth) {
    srcset = Object.keys(srcsetWidth).reduce((result: { [key: string]: string }, key) => {
      result[key] = getSrc({
        away: awayTeamId,
        home: homeTeamId,
        ratio,
        width: srcsetWidth[key as keyof object],
      });
      return result;
    }, {});
  }
  return <Image src={src} srcset={srcset} ratio={ratio} {...props} />;
};

export default TeamMatchupImage;
